"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
var debounce = function (fn, delay, immediate) {
    var timer = null;
    return function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        if (timer) {
            clearTimeout(timer);
        }
        if (immediate && !timer) {
            fn.call.apply(fn, __spreadArrays([null], params));
        }
        else {
            timer = setTimeout(function () {
                timer = null;
                fn.call.apply(fn, __spreadArrays([null], params));
            }, delay);
        }
    };
};
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map